import {
  COLOR_MAP_CUSTOM_ROUTE_1,
  COLOR_MAP_CUSTOM_ROUTE_1_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_2,
  COLOR_MAP_CUSTOM_ROUTE_2_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_3,
  COLOR_MAP_CUSTOM_ROUTE_3_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_4,
  COLOR_MAP_CUSTOM_ROUTE_4_OUTLINE,
  COLOR_MAP_ROUTE,
  COLOR_MAP_ROUTE_OUTLINE
} from '@alltrails/denali/tokens';

export const getUppercaseColor = (color: string) => color.toUpperCase();

export const LINE_COLORS = [
  getUppercaseColor(COLOR_MAP_ROUTE),
  getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_1),
  getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_2),
  getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_3),
  getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_4)
];

const LINE_COLOR_ORDER = LINE_COLORS.reduce(
  (acc, color, index) => {
    acc[getUppercaseColor(color)] = index;
    return acc;
  },
  {} as Record<string, number>
);

const LINE_COLOR_MAP = {
  ['#428A13']: getUppercaseColor(COLOR_MAP_ROUTE),
  ['#FF0000']: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_1),
  ['#F5D24B']: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_2),
  ['#219AD8']: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_3),
  ['#BE50C8']: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_4)
};

const LINE_OUTLINE_COLORS = {
  [getUppercaseColor(COLOR_MAP_ROUTE)]: getUppercaseColor(COLOR_MAP_ROUTE_OUTLINE),
  [getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_1)]: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_1_OUTLINE),
  [getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_2)]: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_2_OUTLINE),
  [getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_3)]: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_3_OUTLINE),
  [getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_4)]: getUppercaseColor(COLOR_MAP_CUSTOM_ROUTE_4_OUTLINE)
};

export const getLineColor = (color: string) => {
  // Map legacy hex colors to current tokens
  const mapped = LINE_COLOR_MAP[getUppercaseColor(color)];
  if (mapped) {
    return mapped;
  }

  // Normalize case of known token colors
  const upperColor = getUppercaseColor(color);
  return LINE_COLORS.find(c => c === upperColor) || color;
};

export const getLineOutlineColor = (color: string) => {
  const lookupColor = getUppercaseColor(getLineColor(color));
  return LINE_OUTLINE_COLORS[lookupColor] || lookupColor;
};

export const getNextColor = (color: string) => {
  const colorIndex = LINE_COLOR_ORDER[getUppercaseColor(color)];
  if (colorIndex === undefined) {
    return LINE_COLORS[0];
  }
  return LINE_COLORS[(colorIndex + 1) % LINE_COLORS.length];
};

export const getLineColorBySegmentIndex = (index: number) => LINE_COLORS[index % LINE_COLORS.length];
